module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/act/sections/apps/assets/play_store_icon-e16817e56b8c7b832cef9abad00af62a.svg";